export default __webpack_public_path__ + "static/media/floor-and-wall-concept.e7e23b0d.svg";